(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bf-2026-nav"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function navs() {
      return Array.from(document.querySelectorAll('.bf-nav'));
    }

    function targets(nav) {
      return Array.from(nav.querySelectorAll('.bf-nav__link[href^="#"]')).map(function (link) {
        var id = link.getAttribute('href').slice(1);
        return { link: link, section: id ? document.getElementById(id) : null };
      }).filter(function (item) { return item.section; });
    }

    function offset() {
      var header = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-group-height')) || 0;
      var nav = document.querySelector('.bf2026-nav-section');
      var bar = header + (nav ? nav.offsetHeight : 0);
      return Math.max(bar + 24, window.innerHeight * 0.35);
    }

    function update() {
      var line = offset();
      navs().forEach(function (nav) {
        var items = targets(nav);
        var current = null;
        items.forEach(function (item) {
          if (item.section.getBoundingClientRect().top <= line) current = item.link;
        });
        items.forEach(function (item) {
          var on = item.link === current;
          item.link.classList.toggle('is-active', on);
          if (on) item.link.setAttribute('aria-current', 'true');
          else item.link.removeAttribute('aria-current');
        });
      });
    }

    var frame = 0;
    function onScroll() {
      if (frame) return;
      frame = window.requestAnimationFrame(function () {
        frame = 0;
        update();
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update);
    else update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    document.addEventListener('shopify:section:load', update);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-2026-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var brace = '{' + '{';
    var endBrace = '}' + '}';
    var moneyFormat = '¥' + brace + 'amount_no_decimals' + endBrace;

    function moneyToken(name) {
      return new RegExp('\\{\\{\\s*' + name + '\\s*\\}\\}', 'g');
    }

    function formatMoney(cents) {
      var amount = Math.round(Number(cents) / 100).toLocaleString('ja-JP');
      var decimal = (Number(cents) / 100).toLocaleString('ja-JP', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return String(moneyFormat)
        .replace(moneyToken('amount_no_decimals_with_comma_separator'), amount)
        .replace(moneyToken('amount_no_decimals'), amount)
        .replace(moneyToken('amount_with_comma_separator'), decimal)
        .replace(moneyToken('amount'), decimal);
    }

    function activeChoice(card) {
      return card.querySelector('[data-choice].is-active');
    }

    function applyChoice(card, choice) {
      var price = card.querySelector('[data-price]');
      var compare = card.querySelector('[data-compare]');
      var save = card.querySelector('[data-save]');
      var main = card.querySelector('[data-art-main]');
      var more = card.querySelector('[data-more]');
      var cents = choice.dataset.priceCents;
      var compareCents = choice.dataset.compareCents;
      if (!cents || !price) return;
      price.textContent = formatMoney(cents);
      if (compare && compareCents && Number(compareCents) > Number(cents)) {
        compare.textContent = formatMoney(compareCents);
        if (save) save.textContent = formatMoney(Number(compareCents) - Number(cents)) + ' 割引';
      } else {
        if (compare) compare.textContent = '';
        if (save) save.textContent = '';
      }
      if (main && choice.dataset.image) main.src = choice.dataset.image;
      if (more && !more.hasAttribute('data-fixed-link') && choice.dataset.url) more.href = choice.dataset.url;
    }

    function openCart() {
      var cartDrawer = document.querySelector('cart-drawer-component');
      if (cartDrawer && typeof cartDrawer.open === 'function') cartDrawer.open();
    }

    function cartAddUrl() {
      var route = window.Theme && Theme.routes && Theme.routes.cart_add_url;
      if (!route) return '/cart/add.js';
      return route.endsWith('.js') ? route : route + '.js';
    }

    function add(card, checkout, button) {
      if (card.classList.contains('is-busy')) return;
      var choice = activeChoice(card);
      var error = card.querySelector('[data-error]');
      var variantId = choice && choice.dataset.variantId;
      var qty = Math.max(1, Number((card.querySelector('[data-qty]') || {}).value || 1));
      if (!variantId) {
        var fallback = card.querySelector('[data-more]');
        if (fallback && fallback.href) window.location.href = fallback.href;
        return;
      }
      if (error) {
        error.hidden = true;
        error.textContent = '';
      }
      card.classList.add('is-busy');
      if (button) {
        button.classList.add('is-loading');
        button.setAttribute('aria-busy', 'true');
      }
      var keepLoading = false;
      var sectionIds = Array.from(document.querySelectorAll('cart-items-component')).map(function (item) { return item.dataset.sectionId; }).filter(Boolean);
      var body = { items: [{ id: Number(variantId), quantity: qty }] };
      if (sectionIds.length) {
        body.sections = sectionIds.join(',');
        body.sections_url = window.location.pathname;
      }
      fetch(cartAddUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (response) {
        return response.json().then(function (payload) { return { ok: response.ok, payload: payload }; });
      }).then(function (result) {
        if (!result.ok || result.payload.status) {
          if (error) {
            error.hidden = false;
            error.textContent = result.payload.description || result.payload.message || 'カートに追加できませんでした';
          }
          return;
        }
        if (checkout) {
          keepLoading = true;
          var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
          window.location.href = root + 'checkout';
          return;
        }
        return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (res) { return res.json(); }).then(function (cart) {
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: card.id,
              data: { source: 'bf-2026', itemCount: cart.item_count, variantId: String(variantId), sections: result.payload.sections || {} }
            }
          }));
          openCart();
        });
      }).catch(function () {
        if (error) {
          error.hidden = false;
          error.textContent = 'カートに追加できませんでした';
        }
      }).finally(function () {
        if (keepLoading) return;
        card.classList.remove('is-busy');
        if (button) {
          button.classList.remove('is-loading');
          button.removeAttribute('aria-busy');
        }
      });
    }

    function bindCard(card) {
      if (!card || card.dataset.bfReady === 'true') return;
      card.dataset.bfReady = 'true';
      card.querySelectorAll('[data-choice]').forEach(function (choice) {
        choice.addEventListener('click', function () {
          card.querySelectorAll('[data-choice]').forEach(function (item) {
            item.classList.remove('is-active');
            item.setAttribute('aria-pressed', 'false');
          });
          choice.classList.add('is-active');
          choice.setAttribute('aria-pressed', 'true');
          applyChoice(card, choice);
        });
      });
      var qty = card.querySelector('[data-qty]');
      var dec = card.querySelector('[data-qty-dec]');
      var inc = card.querySelector('[data-qty-inc]');
      if (dec && qty) dec.addEventListener('click', function () { qty.value = String(Math.max(1, Number(qty.value || 1) - 1)); });
      if (inc && qty) inc.addEventListener('click', function () { qty.value = String(Math.max(1, Number(qty.value || 1) + 1)); });
      var addButton = card.querySelector('[data-add]');
      var buyButton = card.querySelector('[data-buy]');
      if (addButton) addButton.addEventListener('click', function () { add(card, false, addButton); });
      if (buyButton) buyButton.addEventListener('click', function () { add(card, true, buyButton); });
      var current = activeChoice(card);
      if (current && current.dataset.priceCents) applyChoice(card, current);
    }

    function boot() {
      document.querySelectorAll('[data-bf-money]').forEach(function (node) {
        try { moneyFormat = JSON.parse(node.textContent); } catch (error) { moneyFormat = node.textContent || moneyFormat; }
      });
      document.querySelectorAll('[data-bf-card]').forEach(bindCard);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-2026-videos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function youtubeId(url) {
      if (!url) return '';
      if (url.indexOf('watch?v=') !== -1) return url.split('v=').pop().split('&')[0];
      if (url.indexOf('youtu.be/') !== -1) return url.split('youtu.be/').pop().split('?')[0];
      if (url.indexOf('/embed/') !== -1) return url.split('/embed/').pop().split('?')[0];
      return '';
    }

    function closeVideo() {
      var modal = document.querySelector('[data-bf-modal]');
      if (!modal) return;
      modal.hidden = true;
      modal.querySelector('[data-bf-modal-frame]').innerHTML = '';
    }

    function openVideo(id) {
      var modal = document.querySelector('[data-bf-modal]');
      if (!modal) {
        modal = document.createElement('div');
        modal.className = 'bf-modal';
        modal.setAttribute('data-bf-modal', '');
        modal.hidden = true;
        modal.innerHTML = '<button type="button" class="bf-modal__close" data-bf-modal-close aria-label="閉じる">×</button><div class="bf-modal__dialog" data-bf-modal-frame></div>';
        document.body.appendChild(modal);
        modal.addEventListener('click', function (event) {
          if (event.target === modal || event.target.closest('[data-bf-modal-close]')) closeVideo();
        });
        document.addEventListener('keydown', function (event) {
          if (event.key === 'Escape') closeVideo();
        });
      }
      modal.querySelector('[data-bf-modal-frame]').innerHTML = '<iframe src="https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen title="video"></iframe>';
      modal.hidden = false;
    }

    function bindVideos(root) {
      if (!root || root.dataset.bfReady === 'true') return;
      root.dataset.bfReady = 'true';
      var slides = Array.from(root.querySelectorAll('[data-bf-video]'));
      var count = root.querySelector('[data-bf-count]');
      var index = 0;

      function pageCount() {
        var vis = window.matchMedia('(max-width: 989px)').matches ? 1 : Math.min(3, slides.length || 1);
        return Math.max(1, slides.length - vis + 1);
      }

      function render() {
        var pages = pageCount();
        var max = pages - 1;
        if (index > max) index = 0;
        if (index < 0) index = max;
        slides.forEach(function (slide, slideIndex) {
          slide.classList.toggle('is-active', slideIndex === index);
        });
        var slide = slides[0];
        var width = slide ? slide.getBoundingClientRect().width + 18 : 0;
        var track = root.querySelector('[data-bf-track]');
        if (track) track.style.transform = 'translateX(' + (-index * width) + 'px)';
        if (count) count.textContent = (index + 1) + ' / ' + pages;
      }

      var prev = root.querySelector('[data-bf-prev]');
      var next = root.querySelector('[data-bf-next]');
      if (prev) prev.addEventListener('click', function () {
        index -= 1;
        if (index < 0) index = pageCount() - 1;
        render();
      });
      if (next) next.addEventListener('click', function () {
        index += 1;
        if (index > pageCount() - 1) index = 0;
        render();
      });
      slides.forEach(function (slide) {
        slide.addEventListener('click', function () {
          var id = youtubeId(slide.dataset.youtube || '');
          if (!id) return;
          openVideo(id);
        });
      });
      window.addEventListener('resize', render);
      render();
    }

    function boot() {
      document.querySelectorAll('[data-bf-videos]').forEach(bindVideos);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
